import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6aec7e5a"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("th", null, "From"),
  /*#__PURE__*/_createElementVNode("th", null, "Recipients"),
  /*#__PURE__*/_createElementVNode("th", null, "Groups"),
  /*#__PURE__*/_createElementVNode("th", null, "Subject"),
  /*#__PURE__*/_createElementVNode("th")
], -1))
const _hoisted_2 = {
  key: 0,
  class: "filters"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VueMultiSelect = _resolveComponent("VueMultiSelect")!
  const _component_DataTable = _resolveComponent("DataTable")!

  return (_openBlock(), _createBlock(_component_DataTable, {
    class: "table table-striped email-table",
    options: _ctx.options,
    onClickCapture: _cache[3] || (_cache[3] = ($event: any) => (_ctx.selectEmail($event))),
    ref: "datatable",
    key: JSON.stringify([_ctx.sourcesFilter, _ctx.recipientsFilter, _ctx.groupsFilter])
  }, {
    default: _withCtx(() => [
      _createElementVNode("thead", null, [
        _hoisted_1,
        (_ctx.showFilters)
          ? (_openBlock(), _createElementBlock("tr", _hoisted_2, [
              _createElementVNode("th", null, [
                _createVNode(_component_VueMultiSelect, {
                  modelValue: _ctx.sourcesFilter,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.sourcesFilter) = $event)),
                  options: _ctx.sources,
                  multiple: true
                }, null, 8, ["modelValue", "options"])
              ]),
              _createElementVNode("th", null, [
                _createVNode(_component_VueMultiSelect, {
                  modelValue: _ctx.recipientsFilter,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.recipientsFilter) = $event)),
                  options: _ctx.recipients,
                  "track-by": "id",
                  label: "emailAddress",
                  multiple: true
                }, null, 8, ["modelValue", "options"])
              ]),
              _createElementVNode("th", null, [
                _createVNode(_component_VueMultiSelect, {
                  modelValue: _ctx.groupsFilter,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.groupsFilter) = $event)),
                  options: _ctx.groups,
                  "track-by": "id",
                  label: "name",
                  multiple: true
                }, null, 8, ["modelValue", "options"])
              ]),
              _hoisted_3,
              _hoisted_4
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["options"]))
}